import { ReactNode } from "react";

import PostHogAnalyticsProvider, {
  PostHogAnalyticsGroup,
  PostHogApp,
  PostHogProduct,
} from "common/contexts/PostHogAnalyticsProvider";
import { Feature } from "common/types";

import { featureFlagProperties } from "client/analytics/utils";
import { INITIAL_CLIENT_DATA } from "client/common/utils";

// Must match marketing.constants.POSTHOG_CLIENT_DISTINCT_ID_PREFIX.
const CLIENT_POSTHOG_DISTINCT_ID_PREFIX = "client_";

const { user, clinic } = INITIAL_CLIENT_DATA;
const CLIENT_POSTHOG_IDENTITY = user
  ? {
      uniqueId: `${CLIENT_POSTHOG_DISTINCT_ID_PREFIX}${user.client_id}`,
      vetcoveProfileId: user.vetcove_profile_id,
      email: user.email,
      phoneNumber: user.phone_number,
      firstName: user.first_name,
      lastName: user.last_name,
    }
  : null;

const CLIENT_POSTHOG_GROUPS: PostHogAnalyticsGroup[] = [
  { type: "clinic", key: String(clinic.id), properties: { name: clinic.display_name } },
  { type: "group", key: String(clinic.group.id), properties: { name: clinic.group.name } },
  {
    type: "buyer",
    key: String(clinic.vetcove_buyer_id),
    properties: { name: clinic.display_name },
  },
];

type ClientAnalyticsProviderProps = {
  children: ReactNode;
};

const postHogAnalyticsContext = {
  app: PostHogApp.ClientFe,
  product: PostHogProduct.PHD,
  clinic_id: INITIAL_CLIENT_DATA.clinic.id,
  group_id: INITIAL_CLIENT_DATA.clinic.group.id,
  ...featureFlagProperties(INITIAL_CLIENT_DATA.clinic.features, Feature.ProductSearchCardsV2),
};

const ClientAnalyticsProvider = ({ children }: ClientAnalyticsProviderProps) => {
  return (
    <PostHogAnalyticsProvider
      identity={CLIENT_POSTHOG_IDENTITY}
      groups={CLIENT_POSTHOG_GROUPS}
      context={postHogAnalyticsContext}
      isEnabled={INITIAL_CLIENT_DATA.has_internal_analytics_tracking}
    >
      {children}
    </PostHogAnalyticsProvider>
  );
};

export default ClientAnalyticsProvider;
